import SystemManagementMutationTypes from './SystemManagementMutationTypes';
import SystemManagementService from '../service/SystemManagementService';
import AlertService from '../../../common/alert/AlertService';
import translate from '../../../common/localization/translate';

async function setSelectedSystems({ commit }, systemIds) {
  await commit(SystemManagementMutationTypes.UPDATE_SELECTED_SYSTEMS, systemIds);
}

function setIsLoading({ commit }, isLoading) {
  commit(SystemManagementMutationTypes.UPDATE_IS_LOADING, isLoading);
}

async function activate({ state, commit }) {
  try {
    await SystemManagementService.activate(state.selectedSystems);
    const activateLabel = state.selectedSystems.length > 1
      ? 'administration.cmms.SYSTEMS_ACTIVATED' : 'administration.cmms.SYSTEM_ACTIVATED';
    AlertService.showSuccess(translate(activateLabel));
  } catch (e) {
    AlertService.showError(translate('administration.cmms.SAVE_ERROR'));
  } finally {
    commit(SystemManagementMutationTypes.UPDATE_SELECTED_SYSTEMS, []);
  }
}

async function deactivate({ state, commit }) {
  try {
    await SystemManagementService.deactivate(state.selectedSystems);
    const deactivateLabel = state.selectedSystems.length > 1
      ? 'administration.cmms.SYSTEMS_DEACTIVATED' : 'administration.cmms.SYSTEM_DEACTIVATED';
    AlertService.showSuccess(translate(deactivateLabel));
  } catch (e) {
    AlertService.showError(translate('administration.cmms.SAVE_ERROR'));
  } finally {
    commit(SystemManagementMutationTypes.UPDATE_SELECTED_SYSTEMS, []);
  }
}

const SystemManagementActions = {
  setIsLoading,
  setSelectedSystems,
  activate,
  deactivate,
};

export default SystemManagementActions;
